const USEDESK_SUPPORT = 'https://lib.usedesk.ru/secure.usedesk.ru/widget_159431_24386.js'
const USEDESK_CONSULTANT = 'https://dashboard.fstrk.io/widget3/b7256046-5012-44e8-8340-43c8e97050ad.js'

export const usedeskScript = (isAuth, path, isDesktop) => {
  const isUserHasPaidProducts = false // need api

  if ((!isDesktop && path === '') || ['curriculum', 'geek_university'].includes(path)) {
    return {}
  }

  const src = isAuth && (['education', 'lessons'].includes(path) || isUserHasPaidProducts)
    ? USEDESK_SUPPORT
    : USEDESK_CONSULTANT

  return { src, defer: true, body: true }
}

export const usedeskTooltipScript = () => {
  let usedeskNode: HTMLElement,
    mainUsedeskButton: HTMLElement,
    targetUsedeskTooltip: HTMLElement
  const DELAY = 150
  // const appearanceTime = 15000
  // const disappearanceTime = 45000
  let attemptsNumber = 30 // enough attempts to find Usedesk items
  let wasOpened = false
  let tryChangeUsedeskTooltip = setTimeout(
    changeUsedeskTooltip,
    DELAY
  )

  function changeUsedeskTooltip () {
    findUsedeskElements()

    if ((!mainUsedeskButton || !targetUsedeskTooltip) && attemptsNumber >= 0) {
      tryChangeUsedeskTooltip = setTimeout(
        changeUsedeskTooltip,
        DELAY
      )
      attemptsNumber--
    }

    if (mainUsedeskButton && targetUsedeskTooltip) {
      makeUsedeskTooltipInteractive()
      addCloseButton()
      changeTooltipOpeningConditions()

      clearTimeout(tryChangeUsedeskTooltip)
    }
  }

  function addCloseButton () {
    const closeButton = document.createElement('button')
    closeButton.classList.add('tooltip-label__close-button')
    closeButton.onclick = (event) => {
      event.stopPropagation()
      changeVisibility(targetUsedeskTooltip, 'none')
    }
    targetUsedeskTooltip.appendChild(closeButton)
  }

  function changeTooltipOpeningConditions () {
    mainUsedeskButton.onclick = () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      wasOpened = true
      // changeVisibility(targetUsedeskTooltip, 'none')
    }

    // setTimeout(() => {
    //   if (!wasOpened) { changeVisibility(targetUsedeskTooltip, 'flex') }
    // }, appearanceTime)
    // setTimeout(() => changeVisibility(targetUsedeskTooltip, 'none'), disappearanceTime)
  }

  function changeVisibility (el: HTMLElement, visibility: string) {
    el.style.display = visibility
  }

  function findUsedeskElements () {
    usedeskNode = document.querySelector('#usedesk-messenger') as HTMLElement

    if (usedeskNode) {
      mainUsedeskButton = usedeskNode.querySelector('#uw-main-button') as HTMLElement
      targetUsedeskTooltip = usedeskNode.querySelector(
        '.uw__messenger-layout__buttons .uw__tooltip .uw__tooltip-label'
      ) as HTMLElement
    }
  }

  function makeUsedeskTooltipInteractive () {
    targetUsedeskTooltip.onclick = () => {
      mainUsedeskButton.click()
    }
  }
}
